
import LoaderScreenComponent from '@/components/Shared/LoaderScreen/LoaderScreenComponent';
export default LoaderScreenComponent;
